/**
 * Created by tofael on 11/9/17.
 */
import React from 'react';
import _ from 'underscore.string';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';
import utils from '../../utility/utils';
import globalStyles from '../../utility/styles';

const styles = {
  root: {

  },
  item: {
    minHeight: '50px',
    padding: '5px',
    cursor: 'pointer'
  },
  header: {
    width: 'inherit',
    margin: '0px -10px 0px -8px'
  },
  history: {
    fontSize: '15px',
    color: '#080808',
    fontWeight: 'bold',
    marginTop: '10px',
    marginBottom: '5px'
  },
  date:{
    fontSize: '12px',
    color: '#070707'
  },
  meta: {
    display: 'block',
    fontSize: '12px',
  },
  metaBlock: {
    padding: '5px',
    marginLeft:'5%',
    marginRight:'10%',
    marginBottom:'5px',
    borderRadius:'5px',
    backgroundColor: '#f4f2ef'
  }
};
const getMeta = (data) => (
  Object.getOwnPropertyNames(data).filter((prop, key)=>( !prop.endsWith('id'))
  ));

const ActivityList = ({activityList,showMeta, className, style}) => (
  <div className={className} style={{...styles.root, ...style}}>
    {
      activityList.length >0 &&
      <Subheader style={globalStyles.subheader}>Activity List</Subheader>
    }
    <div>
      {
        activityList.map((activity, index) => (
          <div key={index} style={styles.item}>
            <div style={styles.date}>{utils.toAppDate(activity.activity_time)}</div>
            <div style={styles.history}>{activity.action}</div>
            {
              showMeta && activity.data && getMeta(activity.data).length > 0 &&
              <div style={styles.metaBlock}>
                {
                  getMeta(activity.data).map((prop, key) => (
                    <code key={key} style={styles.meta}> {_.humanize(prop)}: {activity.data[prop]}</code>
                  ))
                }
              </div>
            }
            <Divider inset={false} />
          </div>
        ))
      }
    </div>
  </div>
);

export default ActivityList;


// WEBPACK FOOTER //
// ./src/screens/shared/activity-list.component.js